import {
    CREATE_ACCOUNT_YIELD_SUCCESS,
    DELETE_ACCOUNT_YIELD_SUCCESS,
    FETCH_ACCOUNT_YIELD,
    FETCH_ACCOUNT_YIELDS,
    FETCH_ACCOUNT_YIELDS_FAILURE,
    FETCH_ACCOUNT_YIELDS_SUCCESS,
    FETCH_ACCOUNT_YIELD_FAILURE,
    FETCH_ACCOUNT_YIELD_SUCCESS,
    SORT_ASC,
    UPDATE_ACCOUNT_YIELD_SUCCESS,
    ACCOUNT_YIELD_LIST_FILTER_UPDATE,
    ACCOUNT_YIELD_LIST_FILTER_CATEGORY,
    ACCOUNT_YIELD_LIST_PAGE,
    ACCOUNT_YIELD_LIST_SORT,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'account_name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function accountYields(state = initialState, action) {
    switch (action.type) {
        case FETCH_ACCOUNT_YIELD:
        case FETCH_ACCOUNT_YIELDS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_ACCOUNT_YIELDS_FAILURE:
        case FETCH_ACCOUNT_YIELD_FAILURE:
            return Object.assign({}, state, {
                data: {},
                filter: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_ACCOUNT_YIELDS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case FETCH_ACCOUNT_YIELD_SUCCESS:
            const accountYield = { [action.response.id]: action.response };

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, accountYield),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
            });

        case CREATE_ACCOUNT_YIELD_SUCCESS:
            const createUserYield = { [action.id]: action.response };

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, createUserYield),
                loading: false,
            });

        case UPDATE_ACCOUNT_YIELD_SUCCESS:
            const updateUserYield = { [action.id]: action.response };

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, updateUserYield),
                loading: false,
            });

        case ACCOUNT_YIELD_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case ACCOUNT_YIELD_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case ACCOUNT_YIELD_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case DELETE_ACCOUNT_YIELD_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case ACCOUNT_YIELD_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/accountYieldsReducer.js